import * as classNames from 'classnames';
import { AreasFilterType, StateModalStatus } from 'common/interfaces/state';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppStore } from 'stores/AllStores';
import { StateItem } from './StateItem';

// Styles
const s = require('./StateList.css');

// Props
interface IStateListProps {
    store?: IAppStore;
}

// Component
@inject('store')
@observer
export class StateList extends React.Component<IStateListProps, {}> {
    constructor(props: IStateListProps) {
        super(props);
    }

    public render() {
        // Destructure
        const { state } = this.props.store;

        // Render
        return (
            <div className={s.stateListContainer}>
                {(state.statesSearchedResults.length > 0 && (
                    <div className={s.stateList}>
                        {state.statesSearchedResults.map(
                            (stateSearchResult, stateSearchResultIndex) => {
                                return (
                                    <StateItem
                                        key={'state' + stateSearchResult.id}
                                        onClick={this.handleStateClick}
                                        state={stateSearchResult}
                                    />
                                );
                            }
                        )}
                    </div>
                )) || (
                    <div className={classNames(s.stateList, s.empty)}>
                        <p>No states have been found.</p>
                    </div>
                )}
            </div>
        );
    }

    @action private handleStateClick = (stateId: string, stateName: string) => {
        this.props.store.state.selectedState = {
            id: stateId,
            name: stateName,
        };

        this.props.store.state.modalStatus =
            StateModalStatus.OpenOnSpecificArea;
        this.props.store.state.stateAreasSearch = AreasFilterType.All;
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/state/StateList.tsx